export enum RentalRoutes {
    ROOT = `/mis-seguros/pga/rentas`,
    ROUTE_INSURANCE_POLICY_DETAIL = "/mis-seguros/pga/rentas/:productCode/detalle-poliza/:systemCode/:policyId",
    ROUTE_INSURANCE_COVERAGES = "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId",
    ROUTE_INSURANCE_COVERAGE = "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/cobertura/:coverageId",
    ROUTE_INSURANCE_EXCLUSION = "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/exclusion/:coverageId",
    ROUTE_INSURANCE_INVESTMENTS = "/mis-seguros/pga/rentas/:productCode/inversiones/:systemCode/:policyId",
    ROUTE_INSURANCE_INVESTMENTS_MANAGER = "/mis-seguros/pga/rentas/:productCode/gestiona-inversiones/:systemCode/:policyId",
}
